<i18n src="../../locales/lang.json"></i18n>
<template>
  <div class="container-fluid p-0 m-0">
    <div class="row">
      <div class="col-12 custom-large-text text-center mt-2 mt-md-0">
        {{dayStr}}
      </div>
      <div class="col-12 text-center mb-2 mb-md-0">
        <h3>{{monthFullName}}</h3>
      </div>
    </div>

    <large-container-expand-right v-bind:title="$t('calender')" class="mt-3" @expanded="activateCalender">
      <activator ref="calenderActivator">
        <input-inline-calender-and-dates class="inline" @changed_month="changedMonth" @changed_date="changedDate" ref="dateSelector"></input-inline-calender-and-dates>
      </activator>
    </large-container-expand-right>

    <large-container-expand-right v-show="isLoggedIn" v-bind:title="$store.translate('shift_personnel')" class="mt-3" @expanded="activateShiftPersonel">
      <activator ref="shiftPersonelActivator">
        <shift-personel class="p-3" ref="shiftPersonel"></shift-personel>
       </activator>
    </large-container-expand-right>

    <large-container-expand-right v-show="isLoggedIn" v-bind:title="$t('forum_latest_posts')" class="mt-3" @expanded="activateDiscuss">
      <activator ref="discussActivator">
        <discuss-miniview class="px-2 pb-3"></discuss-miniview>
      </activator>
    </large-container-expand-right>

  </div>
</template>

<script>
  var isLoggedIn = false;
  import moment from 'moment'


  export default {
    name: "startpage-container",
    components: {

    },
    props: {

    },
    data() {
      return {
        momentdate: '',
        dateTitle: '',
        monthFullName: '',
        dayStr: '',
        dayName: '',
        shiftpersonelTitle: '',
        isLoggedIn: false,
        loaded: false,
      };
    },
    methods: {
      activateCalender() {
        this.$refs.calenderActivator.activate().then(() => {
          if (this.loaded == false)
            this.changedDate(new Date());
          this.loaded = true;
        })
      },
      activateShiftPersonel() {
        this.$refs.shiftPersonelActivator.activate().then(() => {
          if (this.loaded == false)
            this.changedDate(new Date());
          this.loaded = true;
        })
      },
      activateDiscuss() {
        this.$refs.discussActivator.activate().then(() => {
          if (this.loaded == false)
            this.changedDate(new Date());
          this.loaded = true;
        })
      },
      changedMonth(date) {

        this.getUserSchedule(date, this.date);
        this.getEvents(date, this.date);

      },
      changedDate(date) {

        var mom = this.$store.getMomentLocale(date);
        this.dateTitle = mom.format("dddd, MMMM Do YYYY");
        this.date = date;
        this.monthFullName = mom.format("MMMM");
        this.dayStr = mom.format("D");
        this.dayName = mom.format("dddd");
        
        this.getUserSchedule(this.date, this.date)
        this.getEvents(this.date, this.date);

        if (this.isLoggedIn) {
          //this.shiftpersonelTitle = this.$store.translate('shift_personnel') + ' - ' + this.dayName;
          if (this.$refs.shiftPersonel !== undefined) {
            this.$refs.shiftPersonel.loadShifts(date);
          }
        }
      },

      getUserSchedule(searchdate, selectedDate) {

        var mom = this.$store.getMomentLocale(searchdate);
        var startOfMonth = mom.startOf('month').format('YYYY-MM-DD');
        var endOfMonth = mom.endOf('month').format('YYYY-MM-DD');

        var array = [];

        try {
          //var url = '/api/AdminEntity/GetUserSchedule?startDate=' + startOfMonth + '&endDate=' + endOfMonth + '&user=' + this.$store.getUsername();
          var url = '/api/Admin/v1/Users/Schedule/' + startOfMonth + '/' + endOfMonth + '/' + this.$store.getUsername();

          this.$http.get(url).then(response => {
            var schedulings = response.data;
            for (var i = 0; i < schedulings.length; i++) {
              array.push({ StartDateString: schedulings[i].date });
            }

            if (this.$refs.dateSelector !== undefined) {
              this.$refs.dateSelector.setHighlightDates(selectedDate, array);
            }

            //hollidays
          });
        }
        catch (err) {
          alert('some error:' + err)
        }

      },
      getEvents(searchdate, selectedDate) {

        var mom = this.$store.getMomentLocale(searchdate);
        var startOfMonth = mom.startOf('month').format('YYYY-MM-DD');
        var endOfMonth = mom.endOf('month').format('YYYY-MM-DD');

        //this.$refs.ticker.start(this.$refs.container.getAttribute('id'));
        var response = this.$http.get('/api/Calender/v1/Events?startDate=' + startOfMonth + '&endDate=' + endOfMonth)
          .then(response => {

            var hollidays = [];
            var importantDates = [];

            for (var i = 0; i < response.data.length; i++) {
              if (response.data[i].Visibility == "public")
                hollidays.push(response.data[i])
              else
                importantDates.push(response.data[i])
            }
            if (this.$refs.dateSelector !== undefined) {
              this.$refs.dateSelector.setHollidayDates(selectedDate, hollidays);
              this.$refs.dateSelector.setImportantDates(selectedDate, importantDates);
            }


            //this.$refs.ticker.end(this.$refs.container.getAttribute('id'));
          });
      },
      getId() {
        return this._uid;
      },

      handleRefresh(val) {
        this.$forceUpdate();
      },
      init() {
        this.isLoggedIn = this.$store.isLoggedIn();
        this.changedDate(new Date());
      }
    },
    computed: {

    },
    watch: {

    },
    mounted() {
      this.init();
    },
    created() {

    },
  };

</script>

<style scoped>
  .custom-checkbox .custom-control-label::before {
    margin-top: 9px;
  }

  .custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
    margin-top: 9px;
  }

  label {
    display: block;
    width: 100%;
  }

  .custom-control-inline {
    display: block;
  }

  .icon-menu {
    color: #ccc;
  }

  .icon-menu {
    color: #000;
  }

  .handle {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/startpage/startpage-container.vue